import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';
import beautify from 'xml-beautifier';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { interval } from 'rxjs';
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-fxcrsdownload',
  templateUrl: './fxcrsdownload.component.html',
  styleUrls: ['./fxcrsdownload.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class FxcrsdownloadComponent implements OnInit {
  apiresult: any;
  hotellistproperty: any;
  PMS_NUM: any
  searchDownload: idsProductList[];
  filterProperty: any;
  ValSearchDownload: string;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  today = new Date();
  hotelSearchDataStatus: any;
  productType: any;
  heartBeatData: any;
  XMLName: any;
  addBtnDisabledFunc: boolean = true;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) {


  }
  lstgetcmlist1: any = [] = [];
  PGF: any
  PGT: any
  totalcount: any = 0;
  pageSize = 50;
  Check: boolean = false;
  // pageSizeOptions: number[] = [40, 50, 100];
  selectedChannel: any;
  DataSource: any = [] = [];
  defaultData: any = [] = [];
  p: Number = 1;
  count: Number = 50;
  User: string;
  Val: string;
  status: any;
  public header: string;
  rateCode: string;
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  public LOGS: any;
  hotellistCopy: any = [] = [];
  hotellist: any = [] = [];
  allproperty: any[];
  selected: string;
  selected1: string;
  selectedItems: string;
  SourceBy: string;
    loginUserID: any;//Indhuja 29122025
  lstTCTOPMSRates: any = [] = [];
  totalcountRates: any = 0;
  // pageSizeRents = 50; 
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>;
  // dataSource: any = [];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  display: Boolean = false;
  displayedColumns: string[] = ['Echotoken', 'Status', 'FXCRS#', 'PMS#', 'Mode', 'Created date', 'Process date', 'XML', 'PaddingXML'];
  Userid: any = [];

    /* Search Field */
    dropdownSettingsDept: IDropdownSettings = {};
    selectedDeptItems: any;
    dropdownDeptData: any;
    currentDateStore: any;
    storeHeartBeatValue: any;
    blinkOfflineHotel: boolean;
    todayFuture:any = new Date();
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  searchBarFilter: boolean = false;

  hideSearchFilter(){
    this.ValSearchDownload = '';
    this.searchBarFilter = false
  }
  ngOnInit() {

    this.FOOTFALL();
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection:true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText:"Search Hotel Code / Name"
    };
  }
  callIDSUsersProperties() {
    this.isProgressing = true;
    this.apiCallIdsService.getBookingDownloadlog()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          this.hotellist = this.apiresult
          this.dropdownDeptData = this.apiresult
          console.log('Property 113 = ', this.hotellist)
          this.hotellistproperty = this.hotellist;
          this.isProgressing = false;
        });

  }

  
  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if(this.selectedDeptItems){
      this.searchBarFilter = false
    this.ValSearchDownload = '';
    if(this.selectedDeptItems.length > 0){
      this.totalcount = 0
      console.log('if condition')
      this.Pmscodevalue = this.selectedDeptItems[0].pmscode
      console.log('pms code value = ',this.Pmscodevalue)
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
      this.addBtnDisabledFunc = false
      // For Online Status
    this.apiCallIdsService
    .readHotelSearch(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHotelSearch =',data)
      this.hotelSearchDataStatus = data[0].recordstatus
      this.productType = data[0].producttype
    });
      this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =',data[0])
        this.heartBeatData = data[0].heartBeat
        
// For blinking the record
const today = new Date()
console.log('Today Date = ',today);
this.currentDateStore = today.toLocaleTimeString('it-IT')
console.log('Today Date = ',this.currentDateStore);
this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
var start = this.storeHeartBeatValue.split(":");
var end = this.currentDateStore.split(":");
var startDate = new Date(0, 0, 0, start[0], start[1], 0);
var endDate = new Date(0, 0, 0, end[0], end[1], 0);
var diff = endDate.getTime() - startDate.getTime();
var hours = Math.floor(diff / 1000 / 60 / 60);
diff -= hours * 1000 * 60 * 60;
var minutes = Math.floor(diff / 1000 / 60);
// console.log('minutes difference',minutes)
console.log('minutes difference', hours + ":"  + minutes)
if((hours + ":"  + minutes) > "0:30"){
  console.log('blinkOfflineHotel true')
  this.blinkOfflineHotel = true
}else{
  console.log('blinkOfflineHotel false')
  this.blinkOfflineHotel = false
}

      });
      interval(2000 * 60).subscribe(() => {
        this.heartbeatFunction();
      });
    }else{
      console.log('Else condition zero')
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
      this.addBtnDisabledFunc = true
    }
  }else{
    console.log('Property Not Selected')
  }
  }
  
  GetParseonlyDateTime(d:any) {
    console.log('GetParseonlyDateTime call',d.substring(12))
    return (d.substring(12));
  }
  heartbeatFunction(){
    this.apiCallIdsService
    .readHeartbeat(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHeartbeat =',data[0])
      this.heartBeatData = data[0].heartBeat
    });
  }

  GetCommonMethodForLog() {
    this.searchBarFilter = true
    this.PGF = "0";
    this.PGT = "50";
    this.GetFXCRSDown();
  }
  GetFXCRSDown() {
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');

    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');

    }
    else {
      this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    }

    this.apiCallIdsService.getBookingLogDownloadRead(this.Pmscodevalue, this.selectedDate, this.selectedTOODate,this.PGF,this.PGT,this.ValSearchDownload)
      .subscribe(
        data => {
          console.log(data);
          if (data.length < 1) {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          else {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.filterProperty = data
            console.log('idsProductList =',this.idsProductList)
            this.totalcount = data[0].totalCount;
            console.log('this.totalcount =',this.totalcount)
            this.dataSource = new MatTableDataSource(this.idsProductList);
           
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data Loaded Successfully');
            this.isProgressing = false;
          }
        });
  }

  pageEvent(e:any) {
    console.log('pageEvent = ', e)
    // console.log('pageIndex = ', e.pageIndex)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.GetFXCRSDown();
  }
  SearchDownload(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { fxresnub: { toString: () => string; }; pmsresnub: { toString: () => string; }; }) => {
      return res.fxresnub.toString().toLocaleLowerCase().match(this.ValSearchDownload.toLocaleLowerCase()) || res.pmsresnub.toString().toLocaleLowerCase().match(this.ValSearchDownload.toLocaleLowerCase());
    });
    if (event == '') {
      console.log('if search')
      this.ValSearchDownload = '';
    }
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }

  Search(event: any) {
    this.hotellist = this.hotellistproperty.filter((res: { pmscode: { toString: () => string; }; pmsname: { toString: () => string; } }) => {
      return res.pmscode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmsname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
    });
    if (event == '') {
      this.Val = '';
      // this.callIDSUsersProperties();
    }
  }

  showXml(xmltype, token) {
    console.log('xmltype =',xmltype)
    console.log('token =',token)
    
    this.status = this.LoadXML(xmltype, token);
  }

  LoadXML(xmltype, token) {
    //alert(token)
    console.log("LoadXML");
    this.isProgressing = true;
    this.loginUserID = localStorage.getItem("Username");//Indhuja 29-12-2025
    this.apiCallIdsService.getBookingLogUploadXML(this.Pmscodevalue,token, xmltype,this.loginUserID)
      .subscribe(data => {
        console.log('XML Response =',data)
        if (data.length > 0 && xmltype == "Received") {
          console.log(xmltype);
          const xml = beautify(data[0].msg);
          this.XMLName = "Received XML From FXCRS"
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }

        else if (data.length > 0 && xmltype == "Posted") {
          console.log(xmltype);
          const xml = beautify(data[0].msg);
          console.log(xml);
          this.XMLName = "Sent XML to PMS"
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }
        else if (data.length < 1) {
          this.toastr.error('No data Found');
          this.isProgressing = false;
        }
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },
      );
  }

  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService.getfootfall(this.User, 'FXCRS/SKYRES', 'booking download')


      .subscribe(
        data => {
        });
  }
}
